// data/pricingData.ts
import { PricingTier, Feature } from "./pricing";

export const tiers: PricingTier[] = [
  {
    id: "free",
    name: "Free",
    subtitle: "pages.Pricing.tiers.free",
    targetLevel: "pages.Pricing.tiers.free",
    support: "Ticket/e-mail",
  },
  {
    id: "premium",
    name: "Premium",
    subtitle: "pages.Pricing.tiers.premium",
    targetLevel: "pages.Pricing.tiers.premium",
    support: "Ticket/e-mail",
  },
  {
    id: "distribution",
    name: "Distribution",
    subtitle: "pages.Pricing.tiers.distribution",
    targetLevel: "pages.Pricing.tiers.distribution",
    support: "Live chat/Ticket/e-mail",
  },
  {
    id: "label",
    name: "Label Services",
    subtitle: "pages.Pricing.tiers.label",
    targetLevel: "pages.Pricing.tiers.label",
    support: "Personal LM/Ticket/e-mail",
  },
];

export const features: Feature[] = [
  // ✅ Recursos básicos (todos com ícone verde ou roxo limitado)

  {
    id: "free-diagnostic",
    labelKey: "pages.Pricing.features.freeDiagnostic",
    availability: {
      free: "full",
      premium: "full",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "complete-diagnostic",
    labelKey: "pages.Pricing.features.completeDiagnostic",
    availability: {
      free: "limited",
      premium: "full",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "goals",
    labelKey: "pages.Pricing.features.goals",
    availability: {
      free: "limited",
      premium: "full",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "strm-class",
    labelKey: "pages.Pricing.features.strmClass",
    availability: {
      free: "limited",
      premium: "full",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "connections",
    labelKey: "pages.Pricing.features.connections",
    availability: {
      free: "limited",
      premium: "full",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "quincy",
    labelKey: "pages.Pricing.features.quincy",
    availability: {
      free: "limited",
      premium: "full",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "advances",
    labelKey: "pages.Pricing.features.advances",
    hasAsterisk: true,
    availability: {
      free: "limited",
      premium: "full",
      distribution: "full",
      label: "full",
    },
  },

  {
    id: "strm-for-label",
    labelKey: "pages.Pricing.features.strmForLabel",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "unlimited-distribution",
    labelKey: "pages.Pricing.features.unlimitedDistribution",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "royalty-splits",
    labelKey: "pages.Pricing.features.royaltySplits",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "catalog-migration",
    labelKey: "pages.Pricing.features.catalogMigration",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "pitching",
    labelKey: "pages.Pricing.features.pitching",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "release-calendar",
    labelKey: "pages.Pricing.features.releaseCalendar",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "pre-save-link",
    labelKey: "pages.Pricing.features.preSaveLink",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "full",
    },
  },
  {
    id: "strm-community",
    labelKey: "pages.Pricing.features.strmCommunity",
    availability: {
      free: "none",
      premium: "none",
      distribution: "full",
      label: "none",
    },
  },

  {
    id: "label-manager",
    labelKey: "pages.Pricing.features.labelManager",
    availability: {
      free: "none",
      premium: "none",
      distribution: "none",
      label: "full",
    },
  },
  {
    id: "2id-presentation",
    labelKey: "pages.Pricing.features.2idPresentation",
    availability: {
      free: "none",
      premium: "none",
      distribution: "none",
      label: "full",
    },
  },
  {
    id: "campaign-management",
    labelKey: "pages.Pricing.features.campaignManagement",
    availability: {
      free: "none",
      premium: "none",
      distribution: "none",
      label: "full",
    },
  },
  {
    id: "clip-delivery",
    labelKey: "pages.Pricing.features.clipDelivery",
    availability: {
      free: "none",
      premium: "none",
      distribution: "none",
      label: "full",
    },
  },
  {
    id: "artistic-collaboration",
    labelKey: "pages.Pricing.features.artisticCollaboration",
    availability: {
      free: "none",
      premium: "none",
      distribution: "none",
      label: "full",
    },
  },
];

// Nota de rodapé para os asteriscos
export const footnote = "pages.Pricing.features.footNote";
export const footnoteCircle = "pages.Pricing.features.footNoteCircle";
